<section [formGroup]="loginDetailsForm" class="bv-vault-login-details tw-mb-0">
  <div class="bv-vault-item-form-row bv-vault-login-details__credentials">
    <bit-form-field disableMargin>
      <bit-label>{{ "username" | i18n }}</bit-label>
      <input bitInput formControlName="username" />
      <button
        type="button"
        bitIconButton="bwi-clone"
        bitSuffix
        [appCopyClick]="loginDetailsForm.controls.username.value"
        [valueLabel]="'username' | i18n"
        showToast
        [label]="'copyUsername' | i18n"
        [disabled]="!loginDetailsForm.controls.username.value"
        data-testid="copy-username-button"
      ></button>
    </bit-form-field>

    <bit-form-field disableMargin class="bv-vault-login-details__password">
      <bit-label>{{ "password" | i18n }}</bit-label>
      <input bitInput formControlName="password" type="password" class="tw-font-mono" />
      @if (
        loginDetailsForm.controls.password.enabled &&
        loginDetailsForm.controls.password.value?.length > 0
      ) {
        <button
          type="button"
          bitIconButton="bwi-check-circle"
          bitSuffix
          data-testid="check-password-button"
          [label]="'checkPassword' | i18n"
          [bitAction]="checkPassword"
        ></button>
      }
      @if (viewHiddenFields) {
        <button
          type="button"
          bitIconButton
          bitSuffix
          data-testid="toggle-password-visibility"
          bitPasswordInputToggle
          (toggledChange)="logVisibleEvent($event, EventType.Cipher_ClientToggledPasswordVisible)"
        ></button>
      }
      <button
        type="button"
        bitIconButton="bwi-clone"
        bitSuffix
        [appCopyClick]="loginDetailsForm.controls.password.value"
        [valueLabel]="'password' | i18n"
        showToast
        [label]="'copyPassword' | i18n"
        [disabled]="!loginDetailsForm.controls.password.value"
        data-testid="copy-password-button"
      ></button>
      @if (loginDetailsForm.controls.password.enabled) {
        <button
          type="button"
          bitIconButton="bwi-generate"
          bitSuffix
          data-testid="generate-password-button"
          [label]="'generatePassword' | i18n"
          [bitAction]="generatePassword"
        ></button>
      }
    </bit-form-field>
  </div>

  @if (hasPasskey) {
    <bit-form-field>
      <bit-label>{{ "typePasskey" | i18n }}</bit-label>
      <input
        bitInput
        readonly
        [value]="fido2CredentialCreationDateValue"
        data-testid="passkey-field"
      />
      @if (loginDetailsForm.enabled && viewHiddenFields) {
        <button
          type="button"
          bitIconButton="bwi-minus-circle"
          buttonType="dangerGhost"
          bitSuffix
          [bitAction]="removePasskey"
          data-testid="remove-passkey-button"
          [label]="'removePasskey' | i18n"
        ></button>
      }
    </bit-form-field>
  }

  <bit-form-field disableMargin>
    <bit-label>
      {{ "authenticatorKey" | i18n }}
      <button
        bitLink
        type="button"
        [bitPopoverTriggerFor]="totpPopover"
        [appA11yTitle]="'learnMoreAboutAuthenticators' | i18n"
        slot="end"
        startIcon="bwi-question-circle"
      ></button>
      <bit-popover #totpPopover [title]="'totpHelperTitle' | i18n">
        <p class="tw-mb-0">
          {{ (canCaptureTotp ? "totpHelperWithCapture" : "totpHelper") | i18n }}
        </p>
      </bit-popover>
    </bit-label>
    <input bitInput formControlName="totp" type="password" class="tw-font-mono" />
    @if (viewHiddenFields) {
      <button
        type="button"
        bitIconButton
        bitSuffix
        data-testid="toggle-totp-visibility"
        bitPasswordInputToggle
        (toggledChange)="logVisibleEvent($event, EventType.Cipher_ClientToggledTOTPSeedVisible)"
      ></button>
    }
    <button
      type="button"
      bitIconButton="bwi-clone"
      bitSuffix
      [appCopyClick]="loginDetailsForm.controls.totp.value"
      [valueLabel]="'authenticatorKey' | i18n"
      showToast
      [label]="'copyValue' | i18n"
      [disabled]="!loginDetailsForm.controls.totp.value"
      data-testid="copy-totp-button"
    ></button>
    @if (canCaptureTotp) {
      <button
        type="button"
        bitIconButton="bwi-camera"
        bitSuffix
        data-testid="capture-totp-button"
        [bitAction]="captureTotp"
        [label]="'totpCapture' | i18n"
      ></button>
    }
  </bit-form-field>
</section>

<vault-autofill-options></vault-autofill-options>
